import Vue from "vue";

const END_POINT = "/misc";

const getConstants = payload =>
  Vue.axios.get(`${END_POINT}/constants/${payload}`);

export { getConstants };
